import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ConstantConfig } from './constant-config';

export class ErrorHandler {
	static handleError(error: unknown, customMessage?: string) {
		let message = '';

		if (error instanceof Error) {
			message = error.message;

			ErrorHandler.logError('An error occurred', message);
			ErrorHandler.logError('An error occurred', error.stack);
		} else if (typeof error === 'string') {
			message = error;
			ErrorHandler.logError('An error occurred', message);
		} else {
			ErrorHandler.logError('An error occurred', message);
		}

		return customMessage || message || 'Unknown error occurred.';
	}

	static extractHttpErrorMessage(exception: unknown, defaultMessage?: string) {
		let message = '';

		if (exception instanceof HttpErrorResponse && exception.status == HttpStatusCode.BadRequest) {
			ErrorHandler.logError('An error occurred', exception.error?.errors);
			message = exception.error?.errors[0];
		} else {
			ErrorHandler.logError('An error occurred', exception as string);
		}

		return message || defaultMessage || 'Something went wrong. Please try again later.';
	}

	static logError(identifier: string, value = '') {
		console.error(`${ConstantConfig.TAG} - ${identifier}`, value);
	}
}
